<template>
  <div class="time-select-wrap">
    <template v-for="(item, index) in list">
      <!-- unavailable: item.value === 3, -->
      <div
        :key="index"
        class="time-item"
        :class="{
          disabled: item.value === 1,
          selected: item.index >= startIndex && item.index <= endIndex,
        }"
        @click="handleClickItem(item)"
      >
        <span class="time-item-text">{{ item.label }}</span>
      </div>
    </template>
  </div>
</template>

<script>
const STATUS = {
  DISABLED: 1,
  AVAILABLE: 2,
  UNAVAILABLE: 3,
};
const labels = [
  '0:00',
  '0:30',
  '1:00',
  '1:30',
  '2:00',
  '2:30',
  '3:00',
  '3:30',
  '4:00',
  '4:30',
  '5:00',
  '5:30',
  '6:00',
  '6:30',
  '7:00',
  '7:30',
  '8:00',
  '8:30',
  '9:00',
  '9:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
  '12:30',
  '13:00',
  '13:30',
  '14:00',
  '14:30',
  '15:00',
  '15:30',
  '16:00',
  '16:30',
  '17:00',
  '17:30',
  '18:00',
  '18:30',
  '19:00',
  '19:30',
  '20:00',
  '20:30',
  '21:00',
  '21:30',
  '22:00',
  '22:30',
  '23:00',
  '23:30',
];
export default {
  components: {},
  props: { value: Array },
  data() {
    return {
      startIndex: -1,
      endIndex: -1,
    };
  },
  computed: {
    list() {
      return labels.map((label, index) => ({
        label,
        index,
        value: (this.value && this.value[index]) || 2,
      }));
    },
  },
  methods: {
    validate(start, end) {
      for (let i = start; i <= end; i++) {
        if (this.list[i].value === STATUS.DISABLED) {
          // if (this.list[i].value === STATUS.UNAVAILABLE || this.list[i].value === STATUS.DISABLED) {
          return false;
        }
      }
      return true;
    },
    emitChange() {
      if (this.startIndex >= 0) {
        console.log(' this.endIndex', this.endIndex);

        const selected = this.list.slice(this.startIndex, this.endIndex + 1);
        const lastLabel =
          this.endIndex === 47
            ? ['24:00']
            : this.list.filter(item => item.index === this.endIndex + 1).map(x => x.label);
        const payload = selected.map(x => x.label);
        console.log('payload', payload, selected, lastLabel);

        this.time = payload;
        this.$emit('onChange', payload, lastLabel);
      } else {
        this.$emit('onChange', []);
      }
    },
    handleClickItem(item) {
      // can't click disabled / unvailable ones
      // if (item.value !== STATUS.AVAILABLE) return;
      if (item.value === STATUS.DISABLED) return;
      if (this.startIndex === -1 && this.endIndex === -1) {
        // no current select
        this.startIndex = item.index;
        this.endIndex = item.index;
      } else if (this.startIndex === this.endIndex) {
        if (this.startIndex === item.index) {
          this.startIndex = -1;
          this.endIndex = -1;
        } else if (item.index > this.startIndex) {
          if (!this.validate(this.startIndex, item.index)) return this.handleUnvalidated(item);
          this.endIndex = item.index;
        } else {
          if (!this.validate(item.index, this.endIndex)) return this.handleUnvalidated(item);
          this.startIndex = item.index;
        }
      } else {
        if (item.index < this.startIndex) {
          if (!this.validate(item.index, this.endIndex)) return this.handleUnvalidated(item);
          this.startIndex = item.index;
        } else if (item.index > this.endIndex) {
          if (!this.validate(this.startIndex, item.index)) return this.handleUnvalidated(item);
          this.endIndex = item.index;
        } else {
          this.startIndex = item.index;
          this.endIndex = item.index;
        }
      }
      this.emitChange();
    },
    handleUnvalidated(item) {
      this.startIndex = item.index;
      this.endIndex = item.index;
      this.emitChange();
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.time-select-wrap {
  display: flex;
  flex-wrap: wrap;
  width: calc(100% + 58px);
  .time-item {
    cursor: pointer;
    height: 62px;
    line-height: 62px;
    width: 148px;
    text-align: center;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 32px;
    color: #5d6067;
    border-radius: 8px;
    margin-right: 29px;
    margin-bottom: 29px;
    font-family: PingFangSC-Regular;

    &.selected {
      background: #00ccbf;
      border: 1px solid #00ccbf;
      color: #ffffff;
    }
    &.disabled {
      background: #e8eaeb;
      border: 1px solid #e8eaeb;
      color: rgba(61, 66, 77, 0.2);
    }
    &.unavailable {
      background: #ffe9e6;
      border: 1px solid #ffe9e6;
      color: #f08778;
    }
    // .time-item-text {
    //   opacity: 0.2;
    // }
  }
}
</style>
